<div class="breadcrum">
    <h1>Companies</h1>
    <div style="margin:auto;"></div>
    <ul class="pull-right btn-list">
        <li>
            <button mat-raised-button color="primary" routerLink="/main/AddCompany">Add Company</button>
        </li>
    </ul>
</div>
<div class="separator-breadcrumb border-top"></div>
<div class="row">
    <div class="col-md-12">
        <div class="card mb-4">
            <div class="card-body">
                <div class="form">
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field>
                                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                              </mat-form-field>
                        </div>
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table mat-table [dataSource]="dataSource">
                              
                                  <!-- Position Column -->
                                  <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> S.No. </th>
                                    <td mat-cell *matCellDef="let element; let i = index;"> {{i+1}}  </td>
                                  </ng-container>

                                  <!-- Position Column -->
                                  <ng-container matColumnDef="CompanyName">
                                    <th mat-header-cell *matHeaderCellDef> Company Name </th>
                                    <td mat-cell *matCellDef="let element"> {{element.CompanyName}} </td>
                                  </ng-container>

                                  <!-- Weight Column -->
                                  <ng-container matColumnDef="edit">
                                    <th mat-header-cell *matHeaderCellDef> Edit </th>
                                    <td mat-cell *matCellDef="let element"> 
                                        <button mat-stroked-button color="primary" (click)="edit(element.CompanyId)"><i class="material-icons">
                                            create
                                        </i></button>    
                                    </td>
                                  </ng-container>
                              
                                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                              
                                <mat-paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>
                              </div>
                              
                              
                              <!-- Copyright 2019 Google LLC. All Rights Reserved.
                                  Use of this source code is governed by an MIT-style license that
                                  can be found in the LICENSE file at http://angular.io/license -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
